import { createActionGroup, emptyProps, props } from '@ngrx/store'

import {
  CreateDeepAgentPayload,
  DeepAgent,
  FeedbackType,
  Message,
  MessageRequest,
} from '../types/deep-agent.dictionary'

export const DeepAgentActions = createActionGroup({
  source: 'DeepAgent',
  events: {
    getDeepAgentResponse: props<{ payload: MessageRequest }>(),
    getDeepAgentResponseStream: props<{ response: Omit<Message, 'author' | 'feedback'> }>(),
    getDeepAgentResponseFailure: props<{ error: string }>(),
    getDeepAgentResponseStreamCompleted: emptyProps(),
    setModels: props<{ models: any[] }>(),
    userSendMessage: props<{
      message: string
      model?: string
      thread_id: string
      action_response: string
      feedback: any | null
      application_id?: string | null
    }>(),
    userSendBuildWorkflowMessage: props<{
      message: string
      model?: string
      thread_id: string
      action_response: string
      feedback: any | null
      application_id?: string | null
      app_version_id?: string | null
    }>(),
    cancelPendingRequest: emptyProps(),
    sendFeedback: props<{
      feedback: FeedbackType
      message: Message
      thread_id: string
      action_response: string
    }>(),
    redoMessage: props<{ message: Message; thread_id: string; action_response: string }>(),
    clearMessages: emptyProps(),
    addInitialMessage: props<{
      initialMessage: string
    }>(),
    // Deep Agent CRUD actions
    saveDeepAgent: props<{ payload: CreateDeepAgentPayload }>(),
    saveDeepAgentSuccess: props<{ agent: DeepAgent }>(),
    saveDeepAgentFailure: props<{ error: string }>(),
    setCurrentAgent: props<{ agent: DeepAgent | null }>(),
  },
})
